<template>
  <pack>
    <zt-title>
      快站管理
      <zt-button type="primary" @click="visible=true" class="btn">添加域名</zt-button>
    </zt-title>
    <el-table class="mt20 table" :data="list" v-loading="loading.table" empty-text="-暂无域名-">
      <el-table-column label="状态" width="90px">
        <template slot-scope="{row}">
          <svg-icon icon="gou" v-if="row.active==1"></svg-icon>
        </template>
      </el-table-column>
      <el-table-column label="域名" prop="url"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{row}">
          <zt-button size="mini" @click="use(row)" :disabled="row.active!=0">使用</zt-button>
          <zt-button size="mini" @click="del(row)" :disabled="row.active!=0">删除</zt-button>
          <!-- <span class="using" v-else>使用中</span> -->
        </template>
      </el-table-column>
    </el-table>
    <zt-dialog
      :append-to-body="true"
      :modal-append-to-body="false"
      title="添加域名"
      :visible.sync="visible"
      @close="url = ''"
      width="600px"
    >
      <span class="tips">例子：https://666.kuaizhan.com</span>
      <zt-input placeholder="请输入域名" type="textarea" v-model="url"></zt-input>
      <zt-button type="primary" class="btn mt20" @click="add">确定</zt-button>
      <div class="clean"></div>
    </zt-dialog>
  </pack>
</template>

<script>
import {
  admin_kuai_url_add,
  admin_kuai_url_delete,
  admin_kuai_url_list,
  admin_kuai_url_active
} from '@/api/kzManage';
export default {
  name: 'kzManage',
  data: () => ({
    url: '',
    visible: false,
    loading: {
      table: false,
    },
    list: [],
  }),
  mounted() {
    this.getList();
  },
  methods: {
    //获取域名列表
    getList() {
      admin_kuai_url_list().then(({ data }) => {
        if (data.error_code == 0) {
          this.list = data.list;
        } else {
          this.$message.error(data.error_message);
        }
      });
    },
    //添加域名
    add() {
      if (this.url == '') {
        this.$message({
          message: '请输入域名',
          type: 'error',
          duration: 2000,
        });
        return;
      } else {
        admin_kuai_url_add({
          url: this.url,
        }).then(({ data }) => {
          if (data.error_code == 0) {
            this.$message({
              message: '添加域名成功',
              type: 'success',
              duration: 2000,
            });
            this.getList();
            this.visible = false;
          } else {
            this.$message({
              message: data.error_message,
              type: 'error',
              duration: 2000,
            });
          }
        });
      }
    },
    //删除域名
    del(row) {
      this.$confirm('是否要删除' + row.url + '?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          admin_kuai_url_delete({
            id: row.id,
          }).then(({ data }) => {
            if (data.error_code == 0) {
              this.$message({
                message: '删除域名成功',
                type: 'success',
                duration: 2000,
              });
              this.getList();
            } else {
              this.$message({
                message: data.error_message,
                type: 'error',
                duration: 2000,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          console.log('取消');
        });
    },
    //使用域名
    use(row) {
      admin_kuai_url_active({
        id: row.id,
      }).then(({ data }) => {
        if (data.error_code == 0) {
          this.$message({
            message: '切换域名成功',
            type: 'success',
            duration: 2000,
          });
          this.getList();
        } else {
          this.$message.error(data.error_message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table .cell {
  text-align: center;
}
#app .el-table {
  .zt-button,
  .el-button {
    display: inline-block;
    margin: 0;
    vertical-align: middle;
    + .zt-button,
    + .el-button {
      margin-top: 0px;
      margin-left: 10px;
    }
  }
}

/deep/ .el-textarea__inner {
  margin-top: 11px;
  height: 143px;
}
/deep/ .el-dialog__body {
  padding-bottom: 20px;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f7f2ff;
}
.tips {
  font-size: 14px;
  font-weight: 400;
  color: rgba(70, 73, 77, 1);
  line-height: 20px;
}
.clean {
  clear: both;
  width: 0px;
  height: 0px;
}
.using {
  color: #0dbe00;
}
.btn {
  float: right;
}
</style>